import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`

export const ThumbnailContainer = styled.div`
  position: relative;

  display: flex;

  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  border: 1px solid var(--border-transparent);
  border-radius: var(--radius-brand);

  width: 60px;
  height: 80px;

  background: var(--bg-primary);
`

export const Thumbnail = styled.img`
  object-fit: cover;

  border-radius: var(--radius-brand);

  width: 100%;
  height: 100%;
`

export const Options = styled.div`
  margin-left: auto;
`
